import React from "react";
import ManageClientForm from "./ManageClientForm";
import ClientList from "./ClientList";

function IndexOfManageClient() {
  return (
    <div className="crd-wrap">
      <ClientList />
    </div>
  );
}

export default IndexOfManageClient;
